export class TextAlignList {
    static list = ['left', 'center', 'right', 'justify'];
    static default = 'left';
}
